export default "__VITE_ASSET__b8d8c912__"